import { render } from "./ServiceProblemFormModal.vue?vue&type=template&id=7adc0f16"
import script from "./ServiceProblemFormModal.vue?vue&type=script&lang=js"
export * from "./ServiceProblemFormModal.vue?vue&type=script&lang=js"

import exportComponent from "/builds/phi-indonesia/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__